/**
 *
 *
 * @export
 * @enum {number}
 * 同步服务Proxy对象支持的命令
 */
export enum CmdTypeFromWorker {
  UPDATE_STATUS = 'UPDATE_STATUS',
  UPDATE_OPERATE_TASK_STATUS = 'UPDATE_OPERATE_TASK_STATUS',
  SHOW_INVALID_FILENAME_DIALOG = 'SHOW_INVALID_FILENAME_DIALOG',
}

export interface CmdFromWorker {
  cmdType: CmdTypeFromWorker;
  param?: unknown;
}
